import React, { memo, useCallback, useEffect, useState } from "react";
import TextInput from "./atoms/TextInput";
import classes from "./HeaderController.module.scss";
import axios from "axios";
import { ErrorModal } from "../aquaDrafts/atoms/ErrorModal";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loadingText, loadingState } from "../../states/loadingState";
import { userState } from "../../states/userState";

const HeaderController = memo((props) => {
  const { productNo, setProductNo, setKintoneArray } = props;
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const [title, setTitle] = useState("APIエラー");
  const [message, setMessage] = useState("レコードの取得に失敗しました");
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const user = useRecoilValue(userState); //ユーザー情報取得
  //クエリ取得

  const handleOnChange = (e) => {
    const value = e.target.value;
    const regex = /^\d{8}(-\d{2})?$/;
    if (regex.test(value) || /^\d{0,8}(-\d{0,2})?$/.test(value)) {
      setProductNo(value);
    }
  };
  const handleOnFocus = (e) => {
    setProductNo("");
  };
  useEffect(() => {
    if (!user.isAuth) return;
    (async () => {
      await fetchDrafts();
    })();
  }, []);
  const fetchDrafts = useCallback(async () => {
    console.log("onfetchDrafts:productNo", productNo);
    const params = {
      productNo: productNo.split("-")[0] ?? "",
      productBno: productNo.split("-")[1] ?? "",
      keywords: "",
      fromDate: "",
      toDate: "",
      latestOnly: false,
    };
    const queryParams = new URLSearchParams(params).toString();
    try {
      setLoadingAnimation(true);
      setLoadingText("取得中...");
      const startTime = Date.now(); // リクエスト前の時刻を記録
      const res = await axios.get(
        // `http://localhost:5000/api/Drawing/getDrawing/?${queryParams}`
        `https://kintoneconnect-qdbwxdfcvq-an.a.run.app/api/Drawing/getDrawing/?${queryParams}`
      );
      const endTime = Date.now(); // リクエスト後の時刻を記録
      const duration = endTime - startTime; // ミリ秒単位での時間差を計算
      console.log(`APIのフェッチ時間: ${duration}ms`);
      console.log("res.data", res.data, "productNo", productNo);
      setKintoneArray(res.data);
      setIsShowErrorDialog(false);
    } catch (error) {
      setIsShowErrorDialog(true);
      // window.alert(error);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  }, [productNo]);
  return (
    <>
      <div className={classes.rootContainer}>
        <div className={classes.keywords}>
          <TextInput
            fullWidth={false}
            label={"製作番号入力"}
            multiline={false}
            required={false}
            onChange={handleOnChange}
            onFocus={handleOnFocus}
            minRows={1}
            value={productNo}
            type={""}
            InputProps={true}
            placeholder={"01234567-01"}
            onClick={fetchDrafts}
          />
        </div>
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </>
  );
});

export default HeaderController;
